/** 
 * Class to hold references to different esri geometry types
 */
export class geometry {
  static POLYGON = 'polygon';
  static POLYLINE = 'polyline';
}